import React from 'react';
import {
  Form, Input, Select, DatePicker, Checkbox,
} from 'antd';

export enum FormItemType {
  Input = 'input',
  Select = 'select',
  CheckBox = 'checkBox',
  TextArea = 'textarea',
  Date = 'date'
}

export interface FormItemComponentProps {
  name: string;
  label?: string;
  rules?: any[];
  type?: FormItemType;
  placeholder?: string;
  options?: { value: any; label: string }[];
  [key: string]: any;
}

export const FormItem: React.FC<FormItemComponentProps> = ({
  name,
  label,
  rules,
  type = FormItemType.Input,
  placeholder,
  options,
  ...props
}) => {
  const renderField = () => {
    switch (type) {
    case FormItemType.Select:
      return (
        <Select placeholder={placeholder}>
          {options?.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      );
    case FormItemType.CheckBox:
      return <Checkbox />;
    case FormItemType.TextArea:
      return <Input.TextArea placeholder={placeholder} />;
    case FormItemType.Date:
      return <DatePicker style={{ width: '100%' }} />;
    default:
      return <Input placeholder={placeholder} />;
    }
  };

  return (
    <Form.Item name={name} label={label} rules={rules} {...props}>
      {renderField()}
    </Form.Item>
  );
};
